<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <ResponseItem
        v-for="(option) in responses"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="true"
        :class="{
          'correct': option.correct,
          'incorrect': !option.correct,
        }"
      />
    </template>
    <template #answers>
      <ResponseItem
        v-for="(option) in answers"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="false"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>

<script>
import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    ResponseItem,
    TwoColumnQuizReviewLayout,
  },
  props: {
    dataAnswer: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    answers() {
      return this.dataAnswer?.slideDetails?.SlideOptions
    },
    responses() {
      const matchPairAnswers = this.dataAnswer?.Answer?.pairs
      if (!matchPairAnswers || matchPairAnswers.length === 0) {
        return []
      }

      return matchPairAnswers.map((res) => {
        const { answer: answerId, prompt: promptId } = res
        const answer = this.answers.find((item) => item.id === answerId)
        const prompt = this.answers.find((item) => item.id === promptId)
        return {
          ...prompt,
          pairTitle: answer?.pairTitle ? answer?.pairTitle : '',
          pairImageCropped: answer?.pairImageCropped ? answer?.pairImageCropped : null,
          correct: answerId === promptId,
        }
      })
    },
  },
}
</script>
